module.exports = __webpack_public_path__ + "static/media/default.4d93d80a.jpg";